import FwGeneratorCreateCode from './generator/createCode/index.vue'
import FwGeneratorSysDict from './generator/sysDict/index.vue'

const customChart = {
  FwGeneratorCreateCode,FwGeneratorSysDict
};

const install = function(Vue, opts = {}) {
  Vue.component("FwGeneratorCreateCode",FwGeneratorCreateCode)
  Vue.component("FwGeneratorSysDict",FwGeneratorSysDict)
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default Object.assign(customChart, { install });



// WEBPACK FOOTER //
// ./src/components/index.js